import {useEffect, useRef, useState} from "react";
import FirmSelectList from "../firm/FirmSelectList";
import {t} from 'i18next'
import {Button, Form, Select, Space, Table} from "antd";
import ApiService from "../../core/service/ApiService";
import {useUser} from "../../core/context/UserContext";
import UserSelectList from "../user/UserSelectList";

export default function InstitutionFirmForm({institutionId}) {
    const formRef = useRef(null)
    const [institutionFirms, setInstitutionFirms] = useState([])
    const selectedId = useRef(null)
    const {firmSettings} = useUser()

    const get = async () => {
        const res = await ApiService.Institution.GetInstitutionFirms(institutionId)
        if (res.success) {
            setInstitutionFirms(res.data);
        }
    }

    const onFinish = async () => {
        const data = formRef.current.getFieldsValue();
        if(selectedId.current) {
            const res = await ApiService.Institution.EditInstitutionFirm(institutionId, data.firmId, {...data})
            if(res.success) {
                await get()
                formRef.current.resetFields()
                selectedId.current = null
            }
        }
        else {
            const res = await ApiService.Institution.AddInstitutionFirm(institutionId, {...data})
            if(res.success) {
                await get()
                formRef.current.resetFields()
                selectedId.current = null
            }
        }
    }

    useEffect(() => {
        get()
    }, []);

    return (
        <>
            <Form
                ref={formRef}
                layout="inline"
                onFinish={onFinish}
            >
                <Form.Item
                    label={t('Firm')}
                    name={'firmId'}
                >
                    <FirmSelectList
                        all={true}
                        style={{width: 200}}
                        size={'small'}
                        placeholder={t('Select Firm')}
                    />
                </Form.Item>
                <Form.Item
                    label={t('Responsible')}
                    name={'userId'}
                >
                    <UserSelectList />
                </Form.Item>
                <Form.Item
                    label={''}
                >
                    <Button
                        type={'primary'}
                        size={'small'}
                        htmlType={'submit'}
                    >
                        {t('Save')}
                    </Button>
                </Form.Item>
            </Form>

            <Table
                style={{marginTop: 16}}
                size={'small'}
                dataSource={institutionFirms}
                columns={[
                    {
                        title: t('Firm'),
                        key: 'firmId',
                        render: (text, row) => row?.firm?.name,
                        width: 200
                    },
                    {
                        title: t('Responsible'),
                        key: 'userId',
                        render: (text, row) => row?.user?.name,
                        width: 200
                    },
                    {
                        title: t('#'),
                        key: '#',
                        render: (text, row) => (
                            <Space>
                                <a
                                    key="edit"
                                    onClick={() => {
                                        formRef.current.setFieldsValue({
                                            firmId: row.firmId,
                                            userId: row.userId,
                                        })
                                        selectedId.current = row.id
                                    }}
                                >
                                    {t('Edit')}
                                </a>
                                <a
                                    key="delete"
                                    onClick={async () => {
                                        const res = await ApiService.Institution.DeleteInstitutionFirm(institutionId, row?.firmId)
                                        if(res.success) {
                                            await get()
                                        }
                                    }}
                                    style={{color: 'red'}}
                                >
                                    {t('Delete')}
                                </a>
                            </Space>
                        ),
                    },
                ]}
            />
        </>
    )
}